import {Typography} from 'components/Typography';
import {FilterSwitch} from 'plugins/modules/filter/components/FilterSwitch';
import classNames from 'classnames';
import React, {FC, useEffect, useState} from 'react';
import style from './style.module.scss';
import {FilterHint} from 'plugins/modules/filter/components/FilterHint';

export interface IProps {
    hint?: string;
    isDefaultChecked: boolean;
    onChange: (isChecked: boolean) => void;
    title: string;
}

export const CheckboxAlone: FC<IProps> = ({hint, isDefaultChecked, onChange, title}) => {
    const [currentIsDefaultChecked, setCurrentIsDefaultChecked] = useState(isDefaultChecked);
    const [isChecked, setIsChecked] = useState(isDefaultChecked);

    useEffect(() => {
        if (currentIsDefaultChecked === isDefaultChecked) {
            return;
        }

        setCurrentIsDefaultChecked(isDefaultChecked);
        setIsChecked(isDefaultChecked);
    }, [currentIsDefaultChecked, isDefaultChecked]);

    const handleChange = () => {
        const value = !isChecked;

        setIsChecked(value);
        onChange(value);
    };

    return (
        <label className={classNames(style.main, {[style.isChecked]: isChecked})}>
            <input
                data-skeleton-item={true}
                checked={isChecked}
                className={style.checkbox}
                onChange={handleChange}
                type={'checkbox'}
            />
            <span data-skeleton-item={true} className={style.titleBlock}>
                <Typography className={style.content} variant={'label-14-r-fluid'}>
                    {title}
                </Typography>
                {hint && <FilterHint text={hint} />}
            </span>
            <span data-skeleton-item={true} className={style.switch}>
                <FilterSwitch isChecked={isChecked} />
            </span>
        </label>
    );
};
